import * as actions from "Actions";
import * as api from "Api";

export const fetchTagsSuggestions = ({
  name = null,
  nameAttr = null,
  notIn = []
}) => {
  return (dispatch, getState) => {
    let { token } = getState().auth;
    let { lng } = getState().params;
    let filter = [];

    if (null !== name) {
      filter = [
        {
          property: nameAttr,
          value: name,
          operator: "like"
        }
      ];
    }
    if (notIn.length > 0) {
      filter.push({
        property: "id",
        value: notIn.join(","),
        operator: "nin"
      });
    }

    return dispatch(
      actions.setTagsSuggestions(api.getTags({ token, lng, filter }))
    );
  };
};

export const fetchUsersSuggestions = ({ search = "" }) => {
  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;

    return dispatch(
      actions.setUsersSuggestions(
        api.getUsers({ token, search, community: navCommunity })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/filter.js